import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';

export const FJSliceModals = createSlice({
    name: 'modals',
    initialState: {
        warningModalData: {
            title: '',
            content: '',
            display: false,
            footerDates: [],
        },
        previewModalData: {
            data: {},
            display: false,
        },
        upgradeModalData: {
            display: false,
        },

        uploadImageAsPromptModalData: {
            display: false,
        },

        loadingModalData: {
            display: false,
            message: '',
        },
        mobilePreviewData: {
            data: {},
            display: false,
        },

        upgradeTipsModalData: {
            data: {},
            display: false,
        },

        mobileSimplePreviewData: {
            data: {},
            display: false,
        },
        addAsSceneModalBtuStatus: FJConstant.SUCCESS,
        globalLoadingDisplay: false,
        mobileFooterModalData: {
            title: '',
            children: null,
            hasMask: '',
            display: false,
        },
        isShowRecordDisplay: false,
        addMediaLibraryInfo: {
            visible: false,
            list: [],
        },
        autoSelectionNoticeDisplay: false,
    },
    reducers: {
        setSliceWarningModalData: (state, action) => {
            state.warningModalData = action.payload;
        },
        setSlicePreviewModalData: (state, action) => {
            state.previewModalData = action.payload;
        },
        setSliceUpgradeModalData: (state, action) => {
            state.upgradeModalData = action.payload;
        },
        setSliceUploadImageAsPromptModalData: (state, action) => {
            state.uploadImageAsPromptModalData = action.payload;
        },
        setSliceAddAsSceneModalBtuStatus: (state, action) => {
            state.addAsSceneModalBtuStatus = action.payload;
        },
        setSliceLoadingModalData: (state, action) => {
            state.loadingModalData = action.payload;
        },
        setSliceMobilePreviewData: (state, action) => {
            state.mobilePreviewData = action.payload;
        },
        setGlobalLoadingDisplay: (state, action) => {
            state.globalLoadingDisplay = action.payload;
        },
        setMobileFooterModalData: (state, action) => {
            state.mobileFooterModalData = action.payload;
        },
        setSliceUpgradeTipsModalData: (state, action) => {
            state.upgradeTipsModalData = action.payload;
        },
        setMobileSimplePreviewData: (state, action) => {
            state.mobileSimplePreviewData = action.payload;
        },
        setSliceIsShowRecordDisplay: (state, action) => {
            state.isShowRecordDisplay = action.payload;
        },
        setMediaLibraryInfo: (state, action) => {
            state.addMediaLibraryInfo = action.payload;
        },
        setAutoSelectionNoticeDisplay: (state, action) => {
            state.autoSelectionNoticeDisplay = action.payload;
        },
    },
});

export const {
    setSliceWarningModalData,
    setSlicePreviewModalData,
    setSliceUpgradeModalData,
    setSliceUploadImageAsPromptModalData,
    setSliceAddAsSceneModalBtuStatus,
    setSliceLoadingModalData,
    setSliceMobilePreviewData,
    setGlobalLoadingDisplay,
    setMobileFooterModalData,
    setSliceUpgradeTipsModalData,
    setMobileSimplePreviewData,
    setSliceIsShowRecordDisplay,
    setMediaLibraryInfo,
    setAutoSelectionNoticeDisplay,
} = FJSliceModals.actions;

export default FJSliceModals.reducer;
